import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBackendAuth } from './BackendAuthProvider.jsx';
import { Button } from '../ui/Button.jsx';

const LoginButton = () => {
  const { login, loading } = useBackendAuth();
  const { t } = useTranslation('auth');

  const handleLogin = () => {
    login();
  };

  return (
    <Button
      onClick={handleLogin}
      className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50"
      disabled={loading}
    >
      {loading ? t('login.redirecting') : t('login.button')}
    </Button>
  );
};

export default LoginButton;
